import React from "react";
import AddEditServiceProduct from "../../../../Components/AddEditServiceProduct/AddEditServiceProduct";
import {
  useServiceProductsQuery,
  useServicesQuery,
  useUpdateProductOrServieMutation,
} from "../../../../Store/Apis/servicesApi";
import { useLocation, useNavigate } from "react-router-dom";
import Error from "../../../../Components/Error/Error";
import Loader from "../../../../Components/Loader/Loader";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";

const EditProduct = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const productId = queryParams.get("id");

  const serviceProductsApi = useServiceProductsQuery({ keyID: productId });
  const [updateProductOrService, updateProductOrServiceResponse] =
    useUpdateProductOrServieMutation();

  const handleEditServiceProduct = (formData) => {
    console.log(formData);
    updateProductOrService({
      outletID: formData.outletID,
      id: serviceProductsApi.data.data[0].parentId,
      productServiceName: formData.name,
      brandId: formData.brandID,
      isActive: formData.isActive ? 1 : 0,
      type: formData.type.toLowerCase() === "product" ? 1 : 2,
      iconID: formData.iconID,
      childRecords:
        formData.type.toLowerCase() === "product"
          ? formData.productDetails.map((elem) => {
              return {
                childId: elem.childId,
                typeId: elem.productTypeId,
                costPrice: elem.costPrice,
                code: elem.productCode,
                rate: elem.rate,
                reorderLevel: elem.reorderLevel,
                quantity: elem.quantity,
                icon: elem.icon,
                description: elem.description,
                ...(elem.CompanyID ? { CompanyID: elem.CompanyID } : {}),
              };
            })
          : formData.serviceDetails.map((elem) => {
              return {
                childId: elem.childId,
                typeId: elem.serviceTypeId,
                costPrice: elem.costPrice,
                code: elem.serviceCode,
                rate: elem.rate,
                reorderLevel: elem.reorderLevel,
                quantity: elem.quantity,
                icon: elem.icon,
                description: elem.description,
                ...(elem.CompanyID ? { CompanyID: elem.CompanyID } : {}),
              };
            }),
    })
      .then((res) => {
        if (res?.data?.status == 200) {
          toast.success(res?.data?.message, { duration: 7000 });
          navigate("/service/products");
          // window.location.reload();
        } else {
          toast.error(res?.data?.message, { duration: 7000 });
        }
      })
      .catch((err) => {
        toast.error("Something Went Wrong !!", { duration: 7000 });
      });
  };

  return (
    <>
      <div className="row align-items-center justify-content-between mb-4">
        <div className="col">
          <h5 className="fw-500 text-white mb-0">Edit Product/Service</h5>
        </div>
      </div>
      {serviceProductsApi.isError && (
        <>
          <div className="card">
            <div className="card-body">
              <Error />
            </div>
          </div>
        </>
      )}
      {serviceProductsApi.isLoading && (
        <>
          <div className="card">
            <div className="card-body">
              <Loader height="500px" />
            </div>
          </div>
        </>
      )}
      {serviceProductsApi.isSuccess &&
        Array.isArray(serviceProductsApi.data?.data) &&
        serviceProductsApi.data.data.length > 0 && (
          <AddEditServiceProduct
            data={serviceProductsApi.data.data[0]}
            onSubmit={handleEditServiceProduct}
          />
        )}
    </>
  );
};

export default EditProduct;
